import * as React from 'react';
import { InputHandler, BwjInput } from '../../entities/bwj-input';

export interface IBwjInputProps<T, U = T> {
    id: string;
    required: boolean;
    label?: string;
    onUpdate?: InputHandler<U>;
    onFocus?: Function;
    onBlur?: Function;
    input: BwjInput<T>;
}

export interface IBwjInputState<T> {
    input: BwjInput<T>;
}

export abstract class BwjInputBaseComponent<V, P extends IBwjInputProps<V>, S extends IBwjInputState<V>, SS = any>
                                                extends React.Component<P, S, SS> {
    constructor(props: P) {
      super(props);

      this.focusHandler = this.focusHandler.bind(this);
      this.blurHandler = this.blurHandler.bind(this);
    }

    public componentDidMount() {
        this.handleComponentDidMount();
    }

    public componentWillUnmount() {
        this.handleComponentWillUnmount();
    }

    public componentDidUpdate(prevProps:P, prevState: S) {
        // when the value changes on props, update if that value change is different from what is on state
        if(!this.blockValueUpdates) {
            if(prevProps.input !== this.props.input) {
                if(this.hasValueChanged(this.state.input, this.props.input)) {
                    this.setState({
                        input: this.props.input,
                    });
                }
    
                this.handleValueDidChange(this.state.input, this.props.input);
            }
        }

        this.handleComponentDidUpdate(prevProps, prevState);
    }

    protected updateInputField() {
        if(!!this.props.onUpdate) {
            this.props.onUpdate(this.state.input.value);
        }
    }

    protected focusHandler(e:any) {
        // clear any validation error shown
        // @ts-ignore
        this.setState({
            input: new BwjInput<V>(this.state.input.value)
        });
        
        this.handleFocus(e);
        if(!!this.props.onFocus) {
            this.props.onFocus();
        }
    }

    protected blurHandler(e:any) {
        this.updateInputField();

        this.handleBlur(e);
        if(!!this.props.onBlur) {
            this.props.onBlur();
        }
    }

    protected handleComponentDidMount():void {}
    protected handleComponentWillUnmount():void {}
    protected handleComponentDidUpdate(prevProps?:P, prevState?: S):void {}
    protected handleValueDidChange(prevValue: BwjInput<V>, currentValue: BwjInput<V>): void {}
    protected handleFocus(e:any):void {}
    protected handleBlur(e:any):void {}
    protected valuesAreEqual(prev: V | null, current: V | null) { return false; }

    
    private hasValueChanged(prev: BwjInput<V>, current: BwjInput<V>) { 
        if(prev === current) { return false; }
        if((!prev || !current)) { return true; }

        if((prev.validity !== current.validity) || (prev.message !== current.message) ||
            !this.valuesAreEqual(prev.value, current.value)) {
                return true;
        }

        return false;
     }

    protected blockValueUpdates: boolean = false;
  }